module.exports = __webpack_public_path__ + "img/mspp-pgcs.8bb1f894.png";